import React from "react";
import { createGlobalStyle } from "styled-components";

const CSSRenderer = createGlobalStyle`
 ${(props) => extractGlobalCSS(props?.eventCSS)}
 ${(props) => extractGlobalCSS(props?.pageCSS)}

  #page {
    ${(props) => removeGlobalCSS(props?.eventCSS)};
  }
  #page#page {
    ${(props) => removeGlobalCSS(props?.pageCSS)};
  }
`;
const globalCSSRegex = /\/\*fonts\*\/([\s\S]*)\/\*end-fonts\*\//gm;

function extractGlobalCSS(css) {
  if (!css) return "";
  return css.match(globalCSSRegex)?.join("\n") ?? "";
}

function removeGlobalCSS(css) {
  if (!css) return "";
  return css.replace(globalCSSRegex, "");
}

export default function CustomCSSRenderer({ eventCSS, pageCSS }) {
  return <CSSRenderer pageCSS={pageCSS} eventCSS={eventCSS} />;
}
